export default __webpack_public_path__ + "static/media/startlater_1@2x.62ab5a07.jpg";